import React from "react";
import Navbar from "./components/Navbar";
import Landing from "./components/Landing";
import About from "./components/About";
import Skills from "./components/Skills";
import Projects from "./components/Projects";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import MoreInfo from "./components/ProjectsMoreInfo/index";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import "./Scss/App.css";

export default function App() {
  return (
    <Router>
      <Navbar />
      <Switch>
        <Route
          path="/"
          exact
          render={() => (
            <>
              <Landing />
              <About />
              <Skills />
              <Projects />
              <Contact />
            </>
          )}
        />
        <Route path="/:id" exact component={MoreInfo} />
      </Switch>
      <Footer />
    </Router>
  );
}
